import { DOCUMENT_STATUS_SIGNED, DOCUMENT_STATUS_SIGNED_BY_DIRECTOR } from ".";
import Status from "../components/Status";
import { colors } from "./colors";

export const DKP_SIGNINGS = ({ onSign }) => [
  {
    Header: 'ID',
    accessor: 'id',
    width: 50,
  },
  {
    Header: 'Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
    accessor: (row) => {
      if (!row.user) return 'â';
      const { name, surname, middlename } = row.user;
      const fullName = [surname, name, middlename].filter(Boolean).join(' ');
      return fullName || 'â';
    },

  },
  {
    Header: 'ÐÐÐ',
    accessor: (row) => row.user?.iin || 'â',
    width: 100

  },
  {
    Header: 'Ð¢ÐµÐ»ÐµÑÐ¾Ð½',
    accessor: (row) => row.user?.phone || 'â',
    width: 100
  },
  {
    Header: 'ÐÐ°ÑÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ',
    accessor: (row) => {
      if (!row.createdAt) return 'â';
      const date = new Date(row.createdAt);
      return date.toLocaleDateString('ru-RU');
    },
    width: 100
  },
  {
    Header: 'Ð¡ÑÐ°ÑÑÑ',
    accessor: (row) => {
      if (row.statusId == DOCUMENT_STATUS_SIGNED) {
        return <Status status="ÐÐ¶Ð¸Ð´Ð°ÐµÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ°" color={colors.orange} />;
      } else if (row.statusId == DOCUMENT_STATUS_SIGNED_BY_DIRECTOR) {
        return <Status status="ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½" color={colors.green} />;
      }
    },

    disableSortBy: true,
  },
  {
    Header: 'ÐÐµÐ¹ÑÑÐ²Ð¸Ñ',
    accessor: (row) => (
      <div style={{ display: 'flex', gap: 10, flexDirection: 'column', alignItems: 'flex-start', margin: '10px' }}>
        <a 
          href={row.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: 'pointer', color: '#0057FF', background: 'none', border: 'none', marginRight: '10px' }}
        >
          ÐÑÐºÑÑÑÑ
        </a>
        {row.statusId == DOCUMENT_STATUS_SIGNED && (
          <button 
            onClick={() => onSign(row)} 
            style={{ cursor: 'pointer', color: '#0057FF', background: 'none', border: 'none' }}
          >
            ÐÐ·Ð½Ð°ÐºÐ¾Ð¼Ð¸ÑÑÑÑ Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ
          </button>
        )}
      </div>
    ),
    disableSortBy: true,
    width: 200
  },
  {
    Header: ' ',
  }
]; 